import { GetActiveReservationsCountState, GetActiveReservationsCountActionTypes, GET_ACTIVE_RESERVATIONS_COUNT_DATA_REQUEST, GET_ACTIVE_RESERVATIONS_COUNT_DATA_SUCCESS, GET_ACTIVE_RESERVATIONS_COUNT_DATA_FAILURE } from './types';

const defaultState: GetActiveReservationsCountState = {
  isLoading: false,
  errorMessage: "",
  contents: 0
};

export default function getActiveReservationsCount(state = defaultState, action: GetActiveReservationsCountActionTypes): GetActiveReservationsCountState {
  switch (action.type) {
    case GET_ACTIVE_RESERVATIONS_COUNT_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_ACTIVE_RESERVATIONS_COUNT_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_ACTIVE_RESERVATIONS_COUNT_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};